"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.decideAbsenceRequestApiResponseSchema = exports.decideAbsenceRequestApiPayloadSchema = exports.listPendingAbsenceRequestsApiResponseSchema = exports.assistantAbsenceRequestApiResponseSchema = exports.absenceAssistantSummarySchema = void 0;
const zod_1 = require("zod");
const api_1 = require("../global/api");
const absence_enums_1 = require("./absence-enums");
exports.absenceAssistantSummarySchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    firstname: zod_1.z.string(),
    lastname: zod_1.z.string(),
    email: zod_1.z.string(),
});
exports.assistantAbsenceRequestApiResponseSchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    type: (0, api_1.apiEntityTypeSchema)('assistant-absence-requests'),
    attributes: zod_1.z.object({
        assistant: exports.absenceAssistantSummarySchema,
        absenceType: absence_enums_1.absenceTypeSchema,
        fromDate: zod_1.z.coerce.date(),
        toDate: zod_1.z.coerce.date(),
        days: zod_1.z.number().int().min(1),
        reason: zod_1.z.string().nullable(),
        status: absence_enums_1.absenceStatusSchema,
        origin: absence_enums_1.absenceOriginSchema.default('assistant'),
        submittedAt: zod_1.z.coerce.date(),
        decidedAt: zod_1.z.coerce.date().nullable(),
        decidedById: zod_1.z.string().uuid().nullable(),
        decisionComment: zod_1.z.string().nullable().default(null),
    }),
});
exports.listPendingAbsenceRequestsApiResponseSchema = zod_1.z.object({
    data: zod_1.z.array(exports.assistantAbsenceRequestApiResponseSchema),
});
exports.decideAbsenceRequestApiPayloadSchema = zod_1.z.object({
    comment: zod_1.z.string().trim().min(1).optional(),
});
exports.decideAbsenceRequestApiResponseSchema = zod_1.z.object({
    data: exports.assistantAbsenceRequestApiResponseSchema,
});
